// =============================================================================
// vehicleAccidentShared — the vocabulary the phone wizard, the incident page
// and the broker report share for a vehicle accident (mig 482, 1 Nov 2026)
// =============================================================================

// What a photo shows. The wizard tags each photo with one of these; a manager
// tags after-the-event evidence the same way; the broker report groups by it.
export const VEHICLE_PHOTO_TAGS: Array<[string, string]> = [
  ["coretel_vehicle", "Our vehicle"],
  ["third_party",     "Other vehicle"],
  ["details",         "Licence / rego / insurance"],
  ["scene",           "Scene / road"],
  ["sketch",          "Accident sketch / drawing"],
  ["injury",          "Injury — where it hurts"],   // 1 Nov 2026 — the body outline they circled
  ["other",           "Other"],
];
export const photoTagLabel = (tag?: string | null) => VEHICLE_PHOTO_TAGS.find(t => t[0] === tag)?.[1] ?? null;

// "details" photos (a licence, a rego paper) are for the insurer — they print
// on the broker report and never on a client-facing one.
export const isPrivateTag = (tag?: string | null) => tag === "details";

export const MOVEMENT_LABEL: Record<string, string> = {
  stationary: "Stopped / stationary", moving: "Moving", turning: "Turning", reversing: "Reversing", parked: "Parked", other: "Other",
};
